import router from '@/router'
import authentication from '@/services/authentication'

export default {
  addGlobalRequestInterceptors (axios) {
    axios.interceptors.request.use(function (response) {
      router.app.$Progress.start()
      return response
    }, function (error) {
      router.app.$Progress.fail()
      return Promise.reject(error)
    })
  },
  addGlobalResponseInterceptors (axios) {
    axios.interceptors.response.use(function (response) {
      router.app.$Progress.finish()
      return response
    }, function (error) {
      router.app.$Progress.fail()
      if (error.response && error.response.status === 500) {
        router.push({ name: 'ServerError' })
      }
      return Promise.reject(error)
    })
  },
  addUnauthorizedResponseInterceptor (axios) {
    axios.interceptors.response.use(undefined, function (error) {
      if (error.response && error.response.status === 401 && error.response.data && error.response.data.message === 'Expired JWT Token') {
        authentication.logout()
        router.push({ name: 'Login' })
      }
      return Promise.reject(error)
    })
  }
}



// WEBPACK FOOTER //
// ./src/services/axios_interceptors.js